// If using a module system (e.g. via vue-cli), import Vue and VueI18n and then call Vue.use(VueI18n).
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// Ready translated locale messages
const messages = {
  'en-US': {
    views: {
      app: {
        title: "Customer Portal",
        navigation: {
          home: "Home",
          faq: "FAQ",
          login: "Login",
          about: "About",
          account: "Account",
          overview: "Overview",
          logout: "Logout",
          messages: "Messages",
          qualitynotifications: "Complaints"
        },
        notification: {
          close: "Close"
        }
      },
      payments: {
        title: {
          receivedPayments: "Received payments",
          payments: "Payments"
        },
        paymentsTable: {
          header: {
            amount: "Paid amount",
            bookingDate: "Booking date"
          },
          sum: "Sum",
          gross: "Gross",
          net: "Net"
        },
        errors: {
          loadingPayments: "Error while loading payments!",
          loadingProfileBalance: "Error while loading balance!"
        }
      },
      messages: {
        title: {
          messages: "Messages"
        },
        messageList: {
          message: "Message",
          messageInput: "Text goes here …",
          noEntries: "Empty list",
          selectChatOnTheLeftSide: "Select a chat on the left side!",
          fileInput: "Attach pictures here",
          attachments: "Attachments",
          send: "Send"
        },
        errors: {
          loadingMessages: "Error while loading messages!",
          loadingAttachment: "Error while downloading attachment!",
          sendMessage: "Error while sending message!"
        }
      },
      home: {
        welcome: "Welcome to the Leeb customer portal!",
        navigateToSignIn: "Navigate to sign-in."
      },
      error: {
        title: {
          error: "Error :-("
        },
        content: {
          anErrorOccoured: "An error occoured!",
          errorCode: "Error code: ",
          backToHome: "Back to home",
          retry: "Retry?"
        }
      },
      account: {
        profile: 'Profile',
        profileOverview: "Profile overview",
        customer: "Customer",
        balance: "Balance",
        payments: "Payments",
        orders: 'Orders',
        orderList: {
          header: {
            orderNumber: 'Order number',
            createdAt: 'Created at',
            customer: "Customer",
            expectedDelivery: "Expected delivery",
            state: "State",
            actions: ""
          },
          actionDetails: "Details",
          states: {
            processing: "Processing",
            finished: "Done",
            unknown: "Unknown"
          }
        },
        qualityNotifications: {
          title: 'Complaints',
          noPositions: 'no complaints found',
          create: 'Create complaint'
        },
        error: {
          loadProfiles: "Error while loading profiles!",
          loadProfile: "Error while loading customer data!",
          loadReducedMasterOrders: 'Error while loading order data!',
          loadProfileBalance: 'Error while loading balance!',
          loadWorkOrders: 'Error while loading factory order!',
          loadQualityNotifications: 'Error while loading complaints!',
          loadMasterOrders: 'Error while loading master orders!'
        }
      },
      about: {
        imageTitle: "About this web application",
        thisWebApp: "This web application is developed and maintained by:",
        responsible: "Responsible:",
        supportedBy: "Special thanks to:",
        webAppVersion: "Version of the web application:",
        department: "Department:"
      },
      overview: {
        title: {
          orderOverview: "Order overview"
        },
        baseData: "Base data",
        customerNumberExplanation: "Customer number",
        customerNumberAbbreviated: "CU#",
        paymentAddress: "Payment address",
        noPaymentAddress: "Not available",
        deliveryAddress: "Delivery address",
        noDeliveryAddress: "Not available",
        yourAgent: "Your agent at Leeb",
        contactAtLeeb: "Your contact to Leeb",
        messageDialog: {
          title: "Write a message",
          clerk: "Clerk",
          text: "Your message",
          send: "Send"
        },
        workOrdersHeader: {
          orderNumber: "Order number",
          article: "Article",
          amount: "Amount",
          phase: "Phase",
          delivery: "Delivery",
          installation: "Installation",
          actions: ""
        },
        workOrderStates: {
          orderReceival: "Inquiry",
          measuring: "Measuring",
          designing: "Construction",
          production: "Production",
          delivery: "Delivery",
          installation: "Installation",
          unknown: "Unknown"
        },
        timeline: "Timeline",
        error: {
          loadWorkOrders: "Error while loading factory order.",
          loadOrderState: "Error while loading order states.",
          loadMasterOrderData: "Error while loading order.",
          newMessage: "Error while sending message!",
        },
        success: {
          newMessage: "Messagen sent!"
        }
      }
    },
    components: {
      timeline: {
        overallProgress: "Overall progress:",
        phases: {
          orderReceival: {
            name: 'Inquiry',
            text0a: 'We have received your order and have processed it.',
            text0b: 'The order confirmation has been sent to you.',
            text0c: 'If you have questions please contact us.',
            orderConfirmation: "Order confirmation",
            noDocument: "no document available",
            download: "Download"
          },
          measuring: {
            name: 'Measuring',
            text0a: 'To ensure that every balcony, fence and roofing meets your individual requirements, a measurement technician measures a measurement technician measures all lengths, distances, angles and slopes on site. This information is then sent to our technical draughtsmen, who draw up a plan, which is precisely adapted to the local conditions.',
            text0b: 'The measurement technician responsible for your order will contact you directly to arrange a measurement appointment. If preliminary work is required, we ask you to keep us constantly informed about the progress (any delays, completion of the work, etc.).', 
            noAppointmentYet: "No appointment yet",
            text2: 'The measurements for your order are available and form the basis for further technical processing.'
          },
          designing: {
            name: 'Construction',
            text0: 'The technical processing and design of your order will start soon. During this phase, our technicians will prepare the technical drawings for the precise production of your order.',
            text1: 'The technical processing and design of your order are currently in progress. If approval is required before production, you will be contacted by the responsible design engineer.',
            text2: 'The technical processing and design of your order have been completed. All technical drawings and documents for production are prepared.',
          },
          production: {
            name: 'Production',
            text0: 'Production of your order will start soon.',
            text1: "Production of your order has already begun. It won't be long before we can deliver or assemble your ordered product.",
            text2: "The production of your order has been completed.",
          },
          delivery: {
            name: 'Delivery',
            text0: "In the order confirmation you receive from us, you will find the calendar week of your advised delivery or installation date. We will contact you again around 3-4 weeks before the advised date for fine-tuning.",
            text1: "The detailed planning of the delivery of your order has begun. Our logistics staff will contact you to coordinate the delivery date with you.",
            assumedDeliveryDate: "Assumed delivery date",
            noAppointmentYet: "No appointment yet",
            calendarWeek: "Calendar week",
            text2: "Delivery of your order has been completed.",
            deliveryDate: "Delivery date",
            noDeliveryDate: "No delivery date provided",
            warehouseDeliveryInfo: {
              title: 'Warehouse delivery',
              subtitle: 'The delivery destination is to one of our warehouses. For exact details on completion you will be contacted seperately.'
            }
          },
          assembly: {
            text0: "In the order confirmation you receive from us, you will find the calendar week of your advised delivery or installation date. We will contact you again around 3-4 weeks before the advised date for fine-tuning.",
            text1: "Your order will be assembled shortly. The employees from our logistics department or our assembly partners will contact you to coordinate the exact date.",
            assumedAssemblyDate: "Assumed assembly date",
            noAppointmentYet: "No appointment yet",
            calendarWeek: "Calendar week",
            text2: "The assembly of your order is complete.",
            assemblyDate: "Assembly date",
            noAssemblyDate: "No delivery date provided",
            assemblyReport: "Assembly report",
            download: "Download",
            name: 'Installation',
            dateMayVary: "Please bote that the date may vary.",
            done: 'The installation of your order is finished!',
          }
        },
        errors: {
          loadWorkOrder: 'Error while loading factory order!',
          loadMeasurementOrder: 'Error while loading measurement order!',
          loadDocuments: 'Error while loading documents!',
          downloadDocument: 'Error while downloading document!'
        }
      },
      qualityNotificationsCreationDialog: {
        title: 'Create a complaint',
        masterOrder: "Order",
        workOrder: "Factory order",
        note: "Description",
        attachments: "Attachments",
        send: 'Send',
        errors: {
          sendQualityNotification: 'Error while creating complaint!'
        },
        success: {
          sendQualityNotification: 'Complaint created!'
        }
      },
      qualityNotificationPositionComponent: {
        sequence: 'Position',
        complainedWorkOrder: (ctx) => `for ${ctx.named('workOrderDisplayName')}`,
        createdworkorder: 'Created factory order',
        createdworkorderNotCreatedYet: 'not created yet',
        state: 'Position status',
        states: {
          notAccepted: 'Declined',
          accepted: 'Approved',
          done: 'Done',
          new: 'New'
        },
        deliveryCalendarWeek: {
          abbreviation: 'CW',
          explanation: 'Calendar week'
        },
        delivery: 'Delivery',
        deliveryNotCreatedYet: 'not created yet',
        installationCalendarWeek: {
          abbreviation: 'CW',
          explanation: 'Calendar week'
        },
        installation: 'Installation',
        installationNotCreatedYet: 'not created yet',
        problem: 'Problem description',
        solution: 'Solution',
        files: 'Files',
        noFilesAttached: 'No files found',
        fileDownload: 'Download',
        errors: {
          loadQualityNotificationPositionDocuments: 'Error while loading documents.',
          downloadDocument: 'Error while downloading document.'
        }
      },
      qualityNotificationComponent: {
        createdOn: (ctx) => `created on ${ctx.named('formattedDate')}`,
        asignee: 'Asignee',
        notificationStatus: 'Complaint status',
        statuses: {
          new: 'New',
          inProcessing: 'In Processing',
          done: 'Done',
          notAccepted: 'Not accepted'
        },
        deliveryCalendarWeek: {
          abbreviation: 'CW',
          explanation: 'Calendar week'
        },
        delivery: 'Delivery',
        deliveryNotCreatedYet: 'not created yet',
        installationCalendarWeek: {
          abbreviation: 'CW',
          explanation: 'Calendar week'
        },
        installation: 'Installation',
        installationNotCreatedYet: 'not created yet'
      },
      deliveryInstallationDisplay: {
        abbreviationCalendarweek: "Cw.",
        abbreviationCalendarweekExplanation: "Calendar week"
      }
    }
  },
  'de-DE': {
    views: {
      app: {
        title: "Kundenportal",
        navigation: {
          home: "Home",
          faq: 'FAQ',
          login: "Anmelden",
          about: "Über",
          account: "Profil",
          overview: "Überischt",
          logout: "Abmelden",
          messages: "Nachrichten",
          qualitynotifications: "Qualitätsmeldungen"
        },
        notification: {
          close: "Schließen"
        }
      },
      payments: {
        title: {
          receivedPayments: "Zahlungseingänge",
          payments: "Zahlungen"
        },
        paymentsTable: {
          header: {
            amount: "Gezahlter Betrag",
            bookingDate: "Buchungsdatum"
          },
          sum: "Summe",
          gross: "Total",
          net: "Kundensaldo"
        },
        errors: {
          loadingPayments: "Ein Fehler beim Laden der Zahlungen ist aufgetreten!",
          loadingProfileBalance: "Ein Fehler beim Laden des Kontostandes ist aufgetreten!"
        }
      },
      messages: {
        title: {
          messages: "Nachrichten"
        },
        messageList: {
          message: "Nachricht",
          messageInput: "Einen netten Text schreiben …",
          noEntries: "Keine Einträge",
          selectChatOnTheLeftSide: "Auf der linken Seite einen Chat zum Anzeigen auswählen!",
          fileInput: "Hier ist Platz für schöne Fotos",
          attachments: "Anhänge",
          send: "Senden"
        },
        errors: {
          loadingMessages: "Ein Fehler beim Laden der Nachrichten ist aufgetreten!",
          loadingAttachment: "Ein Fehler beim Herunterladen des Anhangs ist aufgetreten!",
          sendMessage: "Ein Fehler beim Versenden der Nachricht ist aufgetreten!"
        }
      },
      home: {
        welcome: "Willkommen im Leeb Kundenportal!",
        navigateToSignIn: "Direkt zur Anmeldung."
      },
      error: {
        title: {
          error: "Fehler :-("
        },
        content: {
          anErrorOccoured: "Ein Fehler ist aufgetreten!",
          errorCode: "Fehlercode: ",
          backToHome: "Zur Startseite zurück",
          retry: "Erneut versuchen?"
        }
      },
      account: {
        profile: 'Profil',
        profileOverview: "Profil-Übersicht",
        customer: "Kunde",
        balance: "Kundensaldo",
        payments: "Zahlungen",
        orders: 'Aufträge',
        orderList: {
          header: {
            orderNumber: 'Nummer',
            createdAt: 'Erstellt am',
            customer: "Kunde",
            expectedDelivery: "vorraussichtliches Lieferdatum",
            state: "Status",
            actions: ""
          },
          actionDetails: "Details",
          states: {
            processing: "In Bearbeitung",
            finished: "Erledigt",
            unknown: "Unbekannt"
          }
        },
        qualityNotifications: {
          title: 'Serviceanfragen',
          noPositions: 'keine Serviceanfragen gefunden :-)',
          create: 'Serviceanfrage anlegen'
        },
        error: {
          loadProfiles: "Beim Laden der Profile ist ein Fehler aufgetreten!",
          loadProfile: "Beim Laden der Kundendaten ist ein Fehler aufgetreten!",
          loadReducedMasterOrders: 'Beim Laden der Auftragsdaten ist ein Fehler aufgetreten!',
          loadProfileBalance: 'Beim Laden des Kontostandes ist ein Fehler aufgetreten!',
          loadWorkOrders: 'Beim Laden des Werksauftrags ist ein Fehler aufgetreten!',
          loadQualityNotifications: 'Beim Laden der Qualitätsmeldungen ist ein Fehler aufgetreten!',
          loadMasterOrders: 'Beim Laden der Hauptaufträge ist ein Fehler aufgetreten!'
        }
      },
      about: {
        imageTitle: "Über diese Web-Applikation",
        thisWebApp: "Diese Web-Applikation wird entwickelt und betreut von:",
        responsible: "Zuständig:",
        supportedBy: "Mit Unterstützung durch:",
        webAppVersion: "Version der Webb-Applikation:",
        department: "Abteilung:"
      },
      overview: {
        title: {
          orderOverview: "Auftragsübersicht"
        },
        baseData: "Stammdaten",
        customerNumberExplanation: "Kundennummer",
        customerNumberAbbreviated: "Kd.Nr.",
        paymentAddress: "Rechnungsadresse",
        noPaymentAddress: "Keine hinterlegt",
        deliveryAddress: "Lieferadresse",
        noDeliveryAddress: "Keine hinterlegt",
        yourAgent: "Ihr Leeb-Partner",
        contactAtLeeb: "Ihr Kontakt zu Leeb",
        messageDialog: {
          title: "Nachricht schreiben",
          clerk: "Sachbearbeiter:in",
          text: "Ihre Nachricht",
          send: "Senden"
        },
        workOrdersHeader: {
          orderNumber: "Auftragsnummer",
          article: "Artikel",
          amount: "Menge",
          phase: "Phase",
          delivery: "Lieferung",
          installation: "Montage",
          actions: ""
        },
        workOrderStates: {
          orderReceival: "Auftragsbearbeitung",
          measuring: "Aufmaß",
          designing: "Konstruktion",
          production: "Produktion",
          delivery: "Lieferung",
          installation: "Montage",
          unknown: "Unbekannt"
        },
        timeline: "Zeitleiste",
        error: {
          loadWorkOrders: "Beim Laden des Werksauftrags ist ein Fehler aufgetreten.",
          loadOrderState: "Ein Fehler beim Laden der Auftragszustände ist aufgetreten.",
          loadMasterOrderData: "Beim Laden des Auftrags ist ein Fehler aufgetreten.",
          newMessage: "Ein Fehler beim senden der Nachricht ist aufgetreten!",
        },
        success: {
          newMessage: "Neue Nachricht erstellt!"
        }
      }
    },
    components: {
      timeline: {
        overallProgress: "Gesamtfortschritt:",
        phases: {
          orderReceival: {
            name: 'Auftragseingang',
            text0a: 'Ihr Auftrag ist bei uns eingegangen und wurde kaufmännisch bearbeitet.',
            text0b: 'Die Auftragsbestätigung und evtl. auch eine Anzahlungsrechnung wurden bereits an Sie versendet.',
            text0c: 'Sollten Sie Fragen zur Abwicklung Ihres Auftrages haben, kontaktieren Sie bitte unsere Auftragsbearbeitung.',
            orderConfirmation: "Auftragsbestätigung",
            noDocument: "Kein Dokument verfügbar",
            download: "Download"
          },
          measuring: {
            name: 'Aufmaß',
            text0a: 'Damit jeder Balkon, Zaun und jede Überdachung Ihren individuellen Vorstellungen entspricht, misst ein Aufmaßtechniker vor Ort alle Längen, Abstände, Winkel und Gefälle. Diese Infos werden daraufhin an unsere technischen Zeichner übermittelt, die einen Plan erstellen, der genau an die örtlichen Gegebenheiten angepasst ist.',
            text0b: 'Der für Ihren Auftrag zuständige Aufmaßtechniker wird Sie bezüglich eines Aufmaßtermins direkt kontaktieren. Sollten Vorarbeiten erforderlich sein, so bitten wir Sie, uns ständig bezüglich des Fortschritts am laufenden zu halten (evtl. Verzögerungen, Abschluss der Arbeiten etc.)',
            appointment: "Appointment:",
            noAppointmentYet: "no appointment yet",
            text2: 'Das Aufmaß für Ihren Auftrag liegt vor und ist die Grundlage für die weitere technische Bearbeitung.'
          },
          designing: {
            name: 'Konstruktion',
            text0: "Die technische Bearbeitung und Konstruktion Ihres Auftrages starten demnächst. In dieser Phase werden die technischen Zeichnungen zur maßgenauen Fertigung Ihres Auftrages von unseren Technikern vorbereitet.",
            text1: 'Die technische Bearbeitung und Konstruktion Ihres Auftrages sind aktuell in Arbeit. Sofern vor der Produktion eine Freigabe erforderlich ist, wird Sie der zuständige Zeichner kontaktieren.',
            text2: 'Die technische Bearbeitung und Konstruktion Ihres Auftrages sind abgeschlossen. Sämtliche technischen Zeichnungen und Unterlagen für die Fertigung sind vorbereitet.'
          },
          production: {
            name: 'Produktion',
            text0: 'Die Fertigung Ihres Auftrages beginnt demnächst.',
            text1: 'Die Fertigung Ihres Auftrages hat bereits begonnen. Es dauert nicht mehr lange, bis wir ihr bestelltes Produkt liefern bzw. montieren können.',
            text2: 'Die Fertigung Ihres Auftrages ist abgeschlossen.'
          },
          delivery: {
            name: 'Lieferung',
            text0: 'In Ihrer Auftragsbestätigung, die Sie von uns bekommen, finden Sie die Kalenderwoche Ihres avisierten Liefer- bzw. Montagetermins. Rund 3-4 Wochen vor dem avisierten Termin kontaktieren wir Sie nochmals zur Feinabstimmung.',
            text1: "Die Feinplanung der Lieferung ihres Auftrags hat begonnen. Um die Termindetails mit Ihnen abzustimmen, werden sich die Mitarbeiter aus unserer Logistik bei Ihnen melden.",
            assumedDeliveryDate: "Vorraussichtliches Lieferdatum",
            noAppointmentYet: "kein Liefertermin angegeben",
            calendarWeek: "Kalenderwoche",
            text2: "Die Lieferung ihres Auftrags ist abgeschlossen.",
            deliveryDate: "Tatsächliches Lieferdatum",
            noDeliveryDate: "kein Lieferdatum angegeben",
            warehouseDeliveryInfo: {
              title: 'Lagerlieferung',
              subtitle: 'Die Auslieferung ihres Auftrags erfolgt in eines unserer Außenläger. Für genauere Informationen des Fertigstellungstermins werden sie gesondert kontaktiert.'
            }
          },
          assembly: {
            text0: "In Ihrer Auftragsbestätigung, die Sie von uns bekommen, finden Sie die Kalenderwoche Ihres avisierten Liefer- bzw. Montagetermins. Rund 3-4 Wochen vor dem avisierten Termin kontaktieren wir Sie nochmals zur Feinabstimmung.",
            text1: "Die Montage Ihres Auftrags wird in Kürze erfolgen. Die Mitarbeiter aus unserer Logistik bzw. unsere Montagepartner werden Sie zur Abstimmung des genauen Termins kontaktieren.",
            assumedAssemblyDate: "Vorraussichlicher Montagetermin",
            noAppointmentYet: "kein Montagetermin angegeben",
            calendarWeek: "Kalenderwoche",
            text2: "Die Montage ihres Auftrags ist abgeschlossen.",
            assemblyDate: "Tatsächliches Montagedatum",
            noAssemblyDate: "kein Montagedatum angegeben",
            assemblyReport: "Montagebericht",
            download: "Download",
            name: 'Montage',
            dateMayVary: "Bitte beachten Sie, dass der Termin sich ändern kann.",
            done: 'Die Montage Ihres Auftrags ist abgeschlossen!'
          }
        },
        errors: {
          loadWorkOrder: 'Ein Fehler beim Laden des Werkauftrags ist aufgetreten!',
          loadMeasurementOrder: 'Ein Fehler beim Laden des Aufmaßauftrags ist aufgetreten!',
          loadDocuments: 'Ein Fehler beim Laden der Dokumente ist aufgetreten!',
          downloadDocument: 'Ein Fehler beim Herunterladen des Dokuments ist aufgetreten!'
        }
      },
      qualityNotificationsCreationDialog: {
        title: 'Serviceanfrage erfassen',
        masterOrder: "Hauptauftrag",
        workOrder: "Werksauftrag",
        note: "Bemerkung",
        attachments: "Anhänge",
        send: 'Abschicken',
        errors: {
          sendQualityNotification: 'Beim Erfassen der Qualitätsmeldung ist ein Fehler aufgetreten!'
        },
        success: {
          sendQualityNotification: 'Die Qualitätsmeldung wurde erfasst!'
        }
      },
      qualityNotificationPositionComponent: {
        sequence: 'Position',
        complainedWorkOrder: (ctx) => `zu ${ctx.named('workOrderDisplayName')}`,
        createdworkorder: 'Angelegter Werksauftrag',
        createdworkorderNotCreatedYet: 'noch nicht angelegt',
        state: 'Status',
        states: {
          notAccepted: 'Abgelehnt',
          accepted: 'Freigegeben',
          done: 'Abgeschlossen',
          new: 'Neu'
        },
        deliveryCalendarWeek: {
          abbreviation: 'KW',
          explanation: 'Kalenderwoche'
        },
        delivery: 'Lieferung',
        deliveryNotCreatedYet: 'noch nicht angelegt',
        installationCalendarWeek: {
          abbreviation: 'KW',
          explanation: 'Kalenderwoche'
        },
        installation: 'Montage',
        installationNotCreatedYet: 'noch nicht angelegt',
        problem: 'Problembeschreibung',
        solution: 'Lösung',
        files: 'Dateien',
        noFilesAttached: 'keine Dateien verfügbar',
        fileDownload: 'Herunterladen',
        errors: {
          loadQualityNotificationPositionDocuments: 'Beim Laden der Dokumente ist ein Fehler aufgetreten!',
          downloadDocument: 'Ein Fehler beim Herunterladen von einem Dokument ist aufgetreten!'
        }
      },
      qualityNotificationComponent: {
        createdOn: (ctx) => `erfasst am ${ctx.named('formattedDate')}`,
        asignee: 'Bearbeiter',
        notificationStatus: 'Meldungs-Status',
        statuses: {
          new: 'Neu',
          inProcessing: 'In Bearbeitung',
          done: 'Abgeschlossen',
          notAccepted: 'Abgelehnt'
        },
        deliveryCalendarWeek: {
          abbreviation: 'KW',
          explanation: 'Kalenderwoche'
        },
        delivery: 'Lieferung',
        deliveryNotCreatedYet: 'noch nicht angelegt',
        installationCalendarWeek: {
          abbreviation: 'KW',
          explanation: 'Kalenderwoche'
        },
        installation: 'Montage',
        installationNotCreatedYet: 'noch nicht angelegt'
      },
      deliveryInstallationDisplay: {
        abbreviationCalendarweek: "Kw.",
        abbreviationCalendarweekExplanation: "Kalenderwoche"
      }
    }
  }
}

const dateTimeFormats = {
  'en-US': {
    short: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
    zCustomMonthYear: {
      year: 'numeric',
      month: 'long',
    }
  },
  'de-DE': {
    short: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
    zCustomMonthYear: {
      year: 'numeric',
      month: 'long',
    }
  }
}

const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: "symbol"
    }
  },
  'de-DE': {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol'
    }
  }
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'de-DE', // set locale
  messages: messages, // set locale messages
  dateTimeFormats: dateTimeFormats,
  numberFormats: numberFormats
})

export default i18n